import React from 'react'
import moment from 'moment'
import _  from 'lodash'
import onClickOutside from 'react-onclickoutside'
import PropTypes from 'prop-types'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendar as farCalendar } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../assets/css/components/date-filter-popout-button.css'
import CalendarPopout from './CalendarPopout'
library.add(farCalendar)

/*

  * Similar to the FilterPopoutButton component, but specialized to only work with
 * setting a date range as opposed to containg a customized form.
 */
class DateFilterPopoutButton extends React.Component {
  static propTypes = {
    /** Callback to be run when the cancel button is clicked or the popout is closed. */
    onCancel:       PropTypes.func,
    /** Callback to be run the Apply button is clicked. This is usually some function that modifies the Redux state */
    onApply:        PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = { isExpanded: false, isStartingCalendarExpanded: false, isEndingCalendarExpanded: false }
  }

  handleExpansionToggle = ()=>
    this.setState({
      isExpanded: !this.state.isExpanded,
      isStartingCalendarExpanded: false,
      isEndingCalendarExpanded: false
    })

  handleToggleStartingCalendar = ()=>
    this.setState({
      isStartingCalendarExpanded: !this.state.isStartingCalendarExpanded,
      isEndingCalendarExpanded: false
    })

  handleToggleEndingCalendar = ()=>
    this.setState({
      isStartingCalendarExpanded: false,
      isEndingCalendarExpanded: !this.state.isEndingCalendarExpanded
    })

  handleCancel = ()=> {
    if(this.state.isExpanded) {
      if(_.isFunction(this.props.onCancel)) {
        this.props.onCancel()
      }
      this.setState({ isExpanded: false })
    }
  }

  handleApply = ()=> {
    this.setState({ isExpanded: false, isStartingCalendarExpanded: false, isEndingCalendarExpanded: false })
    this.props.onApply()
  }

  handleClickOutside = evt => this.handleCancel()

  getButtonClasses = ()=> {
    const base = 'content-filter-button'
    const backgroundClass = this.props.backgroundWhite ? 'white' : null

    return [base, backgroundClass].join(' ')
  }

  handleSelectStartingDate = date => {
    this.props.onSelectStartingDate(date)
    this.setState({ isStartingCalendarExpanded: false })
  }

  handleSelectEndingDate = date => {
    this.props.onSelectEndingDate(date)
    this.setState({ isEndingCalendarExpanded: false })
  }

  getFormattedSelectedStartingDate = ()=> this.props.selectedStartingDate ? moment(this.props.selectedStartingDate).utc().startOf('day').format('MM/DD/YYYY') : 'mm/dd/yyyy'
  getFormattedSelectedEndingDate = ()=> this.props.selectedEndingDate ? moment(this.props.selectedEndingDate).utc().startOf('day').format('MM/DD/YYYY') : 'mm/dd/yyyy'

  render() {
    return(
      <div className='date-filter-popout-wrapper'>
        <div className={this.getButtonClasses()} onClick={this.handleExpansionToggle}>
          <span className='text'>
            Select Date Range <FontAwesomeIcon icon={['far', 'calendar']}/>
          </span>
        </div>
        {this.state.isExpanded &&
          <div className='popout'>
            <div className='filter-header'>
              <h4>Select Date Range</h4>
              <FontAwesomeIcon onClick={()=>this.handleCancel()} icon={['far', 'calendar']}/>
            </div>
            <div className='filter-body'>
              <p>From:</p>
              <div className='field-container'>
                <div onClick={this.handleToggleStartingCalendar} className='date-field'>{this.getFormattedSelectedStartingDate()}<FontAwesomeIcon icon={['far', 'calendar']}/></div>
                {this.state.isStartingCalendarExpanded &&
                  <div className='calendar-container'><CalendarPopout selectedDate={this.props.selectedStartingDate} onSelect={this.handleSelectStartingDate}/></div>
                }
              </div>

              <p>To:</p>
              <div className='field-container'>
                <div onClick={this.handleToggleEndingCalendar} className='date-field'>{this.getFormattedSelectedEndingDate()}<FontAwesomeIcon icon={['far', 'calendar']}/></div>
                {this.state.isEndingCalendarExpanded &&
                  <div className='calendar-container'><CalendarPopout selectedDate={this.props.selectedEndingDate} onSelect={this.handleSelectEndingDate} /></div>
                }
              </div>

              <div className='btn-group'>
                <button type='button' onClick={this.handleApply} className='apply'>Apply Filter</button>
                <button type='button' onClick={this.handleCancel} className='cancel'>Cancel</button>
              </div>
            </div>
          </div>
        }
      </div>

    );
  }
}

export default onClickOutside(DateFilterPopoutButton)
